import React, { Component } from "react";
import { Panel, Modal, Button, FormGroup, FormControl, ControlLabel, Grid, Row, Col, Image, Checkbox, Glyphicon, OverlayTrigger, Tooltip} from "react-bootstrap";
import ReactLoading from 'react-loading';
import Moment from 'react-moment';
import {ToastContainer, ToastStore} from 'react-toasts';
import CSVReader from 'react-csv-reader';
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';
import $ from "jquery";
//Props:
//dropDown
//pressedItem - to check if this is the pressed item, change bg colors
class FormDataDropDown extends Component {
  constructor(props, context) {
      super(props, context);

      this.state = {
      };
      this.uploadFile = React.createRef();
  }

  render() {
    var dropDown = this.props.dropDown;
    var pressedDropDown = this.props.pressedDropDown;

    const title = dropDown.title || null;
    const name = dropDown.name || 'No Dropdown';

    var style = pressedDropDown != null && pressedDropDown.name == dropDown.name ? {width: "100%", padding: 10, backgroundColor: "#f67e4d", color: "#ffffff"} : { width: "100%", padding: 10, color: "#000000"};
    return (<li key={dropDown.name} style={{width: "100%", marginRight: 1000,}} onClick={()=>{
                              $("#csvReader_"+dropDown.name.replace(' ', '_')).value = "";
                              this.props.onClickDropDown(dropDown);
                              }}>
                        <Panel style={style}>
                              <Row>
                                  <Col md={5}>
                                    <div style={{width: "100%", flex: 0, flexDirection: 'row', fontSize: 20, textAlign: 'left'}}>
                                      {title || name}
                                    </div>
                                  </Col>
                                  <Col md={7}>
                                    {/* <div style={{flex: 0, flexDirection: 'row', fontSize: 12, textAlign: 'right'}}>
                                      {dropDown ? "Last Updated: " : "No Dropdown"}
                                      <Moment format="h:mm a on MM/DD/YY " date={new Date()}/>
                                    </div> */}
                                    <div style={{ flex: 0, flexDirection: 'row', textAlign: 'right', marginTop: 20}}>
                                        {
                                          //<Glyphicon glyph="trash" onClick={()=>{this.props.showDeleteDropDownModal({dropDown: dropDown})}} style={{marginLeft: 15, cursor: "pointer"}}/>
                                        }
                                        <OverlayTrigger
                                            placement="top"
                                            delay={200}
                                            overlay={<Tooltip id="overlay-example">
                                                            Upload {dropDown.name} CSV
                                                    </Tooltip>}>
                                                    <Glyphicon glyph="cloud-upload" onClick={()=> {$("#csvReader_"+dropDown.name.replace(' ', '_')).click()}} style={{marginLeft: 15, cursor: "pointer"}}/>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="top"
                                            delay={200}
                                            overlay={<Tooltip id="overlay-example">
                                                            Download {dropDown.name} CSV
                                                    </Tooltip>}>
                                                    <CSVLink data={this.createItemsForCSVDownload(dropDown.items)} filename={dropDown.name+".csv"}>
                                                      <Glyphicon glyph="cloud-download" style={{marginLeft: 15, cursor: "pointer", color: "black"}}/>
                                                    </CSVLink>

                                        </OverlayTrigger>
                                    </div>
                                  </Col>
                                  <CSVReader
                                    cssClass="csv-reader-input"
                                    label=""
                                    onFileLoaded={(matrix, name)=> {
                                      this.validateCSV(matrix, name);
                                    }}
                                    onError={(err)=>{ console.log("error: ", err);}}
                                    inputId={"csvReader_"+dropDown.name.replace(' ', '_')}
                                    inputStyle={{color: 'red', display: 'none'}}
                                  />
                              </Row>


                        </Panel>
              </li>);
  }

  uploadCSV(details) {
    var dropDown = this.props.dropDown;
    var itemToAdd = {};

    details.forEach((item)=>{
      if(item.length > 1) {
        item = this.createItemForType(item, dropDown.name.toLowerCase())
        this.props.onAddItem(item);
      }

    });
    // ToastStore.success("Upload " + details.name + " CSV. API still under construction!");
  }

  downloadCSV(details) {
    ToastStore.success("Download " + details.name + " CSV. API still under construction!");
  }

  createItemForType(item, type) {

    let basic_sql_radio_values = ["client", "branch", "call type", "incident type", "skill", "custom field 1", "custom field 2",  "custom field 3", "custom field 4",  "custom field 5"];
    var formData = {};
    formData["type"] = type;
    if(basic_sql_radio_values.indexOf(type) >= 0) {

      formData["name"]= item[0];
      formData["sortOrder"]=item[1];
      formData["isActive"]= item[2].toLowerCase() === 'true' ? true : false
    } else if (type == "facility") {
        //Hrm.. facility's client column from dropDown.keys isn't being used here. API doesn't require it either. weird. will leave as is for now. -Tere
      formData["name"]= item[1];
      formData["branch"]= this.props.getRecnoForName(item[0], "Branch");
      formData["address"]= item[2];
      formData["sortOrder"]=item[3];
      formData["isActive"]= item[4].toLowerCase() === 'true' ? true : false
    } else if(type == "event") {
      formData["facility"]= this.props.getRecnoForName(item[0], "Facility");
      formData["date"] = moment(item[1]).format("YYYY-MM-DD hh:mm:ss");
      formData["name"] = item[2];
      formData["sortOrder"] = item[3];
    } else if (type == "facility location") {
      formData["name"]= item[1];
      formData["facility"]= this.props.getRecnoForName(item[0], "Facility");
      formData["sortOrder"]=item[2];
      formData["isActive"]= item[3].toLowerCase() === 'true' ? true : false
    } else if (type == "auto email") {
      formData["name"]= item[0];
      formData["branch"]= this.props.getRecnoForName(item[1], "Branch");
      formData["autoEmail"] = item[2];
      formData["sortOrder"]= 0;
    }
    return formData
  }

  createItemsForCSVDownload(items) {
    var newItems = [];
    var dropDown = this.props.dropDown;
    var newItem = null;
      items.map((item)=>{
        newItem = {};
        dropDown.keys.map((key)=>{
          Object.keys(item).map((itemKey)=>{
            if(key === dropDown.name && itemKey === "name") {
              newItem[key] = item[itemKey];
            } else if(itemKey.toLowerCase() === "date" && key.toLowerCase() === "date") {
              newItem[key] = moment(new Date(item[itemKey])).format("MM-DD-YYYY h:mm A");
            } else if(key === "Active" && itemKey === "isActive") {
              newItem[key] = item[itemKey];
            } else if(key === "Form" && dropDown.type === "autoEmail" && itemKey === "name") {
              newItem[key] = item[itemKey];
            } else if(itemKey.toLowerCase() === key.toLowerCase().replace(' ', '')) {
              //Branch is recno instead of name. Change display properties
              newItem[key] = item[itemKey];
            }

          });
        })

        if(newItem != {}) {
          newItems.push(newItem);
        }
      })
      return newItems;
  }

  validateCSV(matrix, name) {
    var isValid = true;
    var missingFields = "Missing Fields: ";
    var extraFields = "Invalid Fields: ";
    var genericCounter = 0;
    var dropDown = this.props.dropDown;

    //Compare if all csv's fields exist in template
    matrix[0].map((field)=>{
      if(dropDown.keys.indexOf(field) < 0) {
        isValid = false
        if(genericCounter == 0) {
            extraFields += ", "
        }
        extraFields += field;
        genericCounter++;
      }
    });
    genericCounter = 0
    //compare if all of template exists in csv
    dropDown.keys.map((key)=>{
      if(matrix[0].indexOf(key) < 0) {
        isValid = false
        if(genericCounter == 0) {
            missingFields += ", "
        }
        missingFields += key;
        genericCounter++;
      }
    });


    if(!isValid) {
      alert("Invalid CSV! \n\n"+ missingFields + "\n\n" + extraFields)
    } else {
      var details = matrix.slice();
      details.splice(0,1);
      this.uploadCSV(details);
    }
  }
}

export default FormDataDropDown;
